import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class RecomendationsService {

  constructor(private http: HttpClient) {}

  createRecomendations(formsId: number, data: any): Observable<any> {
    return this.http.post(`${environment.api_guia}forms/${formsId}/recomendations`, data)
  }

  getRecomendationsData(formsId: number): Observable<any> {
    return this.http.get(`${environment.api_guia}forms/${formsId}/recomendations`);
  }

  updateRecomendationsData(formsId: number, recomendationsId: number, data: any): Observable<any> {
    return this.http.patch(`${environment.api_guia}forms/${formsId}/recomendations/${recomendationsId}`, data);
  }
}
